'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATE_SUCCESS = exports.VALIDATE = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;
exports.validateVat = validateVat;
exports.resetVatValidation = resetVatValidation;

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALIDATE = exports.VALIDATE = 'ms/vat/validate';

var VALIDATE_SUCCESS = exports.VALIDATE_SUCCESS = 'ms/vat/validate_success';
var VALIDATE_FAIL = 'ms/vat/validate_fail';

var initialState = {};

// Reducer

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case VALIDATE:
      return (0, _extends5.default)({}, state, action.payload && (0, _defineProperty3.default)({}, action.payload.vatNo, {
        vatNo: action.payload.vatNo,
        validating: true
      }));

    case VALIDATE_SUCCESS:

      return (0, _extends5.default)({}, state, (0, _defineProperty3.default)({}, action.payload.vatNo, (0, _extends5.default)({}, state[action.payload.vatNo], {
        vatNo: action.result.vatNo,
        signature: action.result.signature,
        validating: false,
        validated: true
      })));

    case VALIDATE_FAIL:
      return (0, _extends5.default)({}, state, (0, _defineProperty3.default)({}, action.payload.vatNo, (0, _extends5.default)({}, state[action.payload.vatNo], {
        validating: false,
        validationError: action.error
      })));

    default:
      return state;
  }
}

// Action creators

function validateVat(_ref2) {
  var vatNo = _ref2.vatNo;

  return function (dispatch, getState) {
    var vat = getState().vat[vatNo];
    if (vat && vat.validated === true && vat.signature) {
      dispatch({ type: VALIDATE_SUCCESS, payload: { vatNo: vatNo }, result: { vatNo: vatNo, signature: vat.signature } });
      return _bluebird2.default.resolve({ vatNo: vatNo });
    }

    return dispatch({
      types: [VALIDATE, VALIDATE_SUCCESS, VALIDATE_FAIL],
      payload: { vatNo: vatNo },
      promise: function promise(client) {
        return client.post('v1/vat/validations', { data: { vatNo: vatNo } }).then(function (result) {
          if (_ramda2.default.propEq('valid', false, result)) {
            throw new Error('We are unable to verify your VAT ID');
          }

          return result;
        });
      }
    });
  };
}

function resetVatValidation() {
  return function (dispatch) {
    return dispatch({
      type: VALIDATE
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/vat.js
// module id = 363
// module chunks = 0